<p *ngIf="!viewtypeshort">{{task.title}}</p>
<p *ngIf="viewtypeshort" class="taskshort">{{task.title}}</p>